// @general/calendar — frontend surface.
//
//   /calendar              the agenda: day, week, month
//   /calendar/events/:id   one event — what opens from a record's file, a
//                          notification or the search box
//
// Plus, mounted once over every screen, the editor any other part of the ERP
// opens with useCalendarEditor().open(draft): the mail reader's «New meeting»,
// a record's «New event», the AI box.

import EditorHost from './components/EditorHost.vue'

export const routes = [
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('./views/CalendarView.vue'),
    // The screen keeps view, day and filter in the address and rewrites it
    // on every step: it must not be remounted each time.
    meta: { permission: 'calendar:use', title: 'calendar.title', ownsQuery: true },
  },
  {
    // No permission of its own: the server opens an event to whoever it
    // reaches — its owner, the invited, whoever can open a record it is
    // linked to — and answers 404 to anybody else.
    path: '/calendar/events/:id',
    name: 'calendar-event',
    component: () => import('./views/EventView.vue'),
    meta: { title: 'calendar.event.title' },
  },
]

export const navigation = [
  { to: '/calendar', labelKey: 'calendar.title', permission: 'calendar:use', icon: 'agenda', group: 'platform', order: 14 },
]

export const overlays = [
  { id: 'calendar-editor', component: EditorHost, permission: 'calendar:use' },
]

export { useCalendarEditor, useCalendarSettings } from './store'
export { useEventActions } from './actions'
// For a record's page with no «related» tabs: its events and «New event».
export { default as RecordAgenda } from './components/RecordAgenda.vue'

export default { routes, navigation, overlays }
